"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var owa_mail_search_store_1 = require("owa-mail-search-store");
var owa_mail_search_view_1 = require("owa-mail-search-view");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var styles = require('./PersonaPillWell.scss');
var PersonaPillWell = /** @class */ (function (_super) {
    tslib_1.__extends(PersonaPillWell, _super);
    function PersonaPillWell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PersonaPillWell.prototype.renderPersonaItems = function () {
        var _this = this;
        var personaItems = [];
        var length = owa_mail_search_store_1.searchStore.personaPillIds.length;
        var _loop_1 = function (i) {
            var personaPillId = owa_mail_search_store_1.searchStore.personaPillIds[i];
            var persona = owa_mail_search_store_1.searchStore.personaPillSuggestions.get(personaPillId);
            personaItems.push(React.createElement("div", { key: i.toString(), className: styles.personaPillBox },
                React.createElement(owa_mail_search_view_1.PersonaPill, { name: persona.DisplayName, emailAddress: persona.EmailAddresses[0], personaPillId: personaPillId, onRemoveClick: this_1.props.onRemovePersona, personaType: 'User' }),
                React.createElement(Button_1.IconButton, { className: styles.removePersonaIcon, iconProps: {
                        iconName: "Cancel" /* Cancel */,
                        styles: {
                            root: styles.cancelIcon,
                        },
                    }, onClick: function () { return _this.props.onRemovePersona(personaPillId); } })));
        };
        var this_1 = this;
        for (var i = 0; i < length; i++) {
            _loop_1(i);
        }
        return personaItems;
    };
    PersonaPillWell.prototype.render = function () {
        return React.createElement("div", { className: styles.personaPillWell }, this.renderPersonaItems());
    };
    PersonaPillWell = tslib_1.__decorate([
        mobx_react_1.observer
    ], PersonaPillWell);
    return PersonaPillWell;
}(React.Component));
exports.default = PersonaPillWell;
//# sourceMappingURL=PersonaPillWell.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-search-view/lib/components/PersonaPillWell.js
// module id = 4837
// module chunks = 37